export default __webpack_public_path__ + "77dd74283dfd7af1a399de8ddc02355c.svg";